/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Shortcuts_Title_AccentInputs */

const tr_landing_shortcuts_title_accent = /** @type {(inputs: Landing_Shortcuts_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bir kısayol.`)
};

const en_landing_shortcuts_title_accent = /** @type {(inputs: Landing_Shortcuts_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`for everything.`)
};

const de_landing_shortcuts_title_accent = /** @type {(inputs: Landing_Shortcuts_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ein Kurzbefehl.`)
};

const ru_landing_shortcuts_title_accent = /** @type {(inputs: Landing_Shortcuts_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`есть быстрая клавиша.`)
};

/**
* | output |
* | --- |
* | "for everything." |
*
* @param {Landing_Shortcuts_Title_AccentInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_shortcuts_title_accent = /** @type {((inputs?: Landing_Shortcuts_Title_AccentInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Shortcuts_Title_AccentInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_shortcuts_title_accent(inputs)
	if (locale === "de") return de_landing_shortcuts_title_accent(inputs)
	if (locale === "ru") return ru_landing_shortcuts_title_accent(inputs)
	return tr_landing_shortcuts_title_accent(inputs)
});